import { render, staticRenderFns } from "./Ratificantes.vue?vue&type=template&id=47b20518&scoped=true"
import script from "./Ratificantes.vue?vue&type=script&lang=js"
export * from "./Ratificantes.vue?vue&type=script&lang=js"
import style0 from "./Ratificantes.vue?vue&type=style&index=0&id=47b20518&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b20518",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b20518')) {
      api.createRecord('47b20518', component.options)
    } else {
      api.reload('47b20518', component.options)
    }
    module.hot.accept("./Ratificantes.vue?vue&type=template&id=47b20518&scoped=true", function () {
      api.rerender('47b20518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificacionesdigital/infoBase/Ratificantes.vue"
export default component.exports